export const OBJECT_TYPES: Readonly<any> = {
    package: 1
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/objectTypes.ts